import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const bovisyncDiscards: ImportTypeConfig = {
  dateFormat: {
    default: 'YYYY-MM-DD',
  },
  instructions: {
    fileInstructionKey: 'select_exported_file',
    software: 'Bovisync',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'bovisync_discards',
}
